import { Grid } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import changeLogo from '../../assets/images/altera-logo.png'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'
import Context from '../../context'
import { getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

const { REACT_APP_IMAGES_URL } = process.env

function ChallengeList() {
  const { setUser, setOpenToast, setAboutCurrentPage } = useContext(Context)
  const [challengeList, setChallengeList] = useState([
    {
      id: 1,
      title: 'Desafio 1',
      description: 'Descricao do desafio',
      image: 'parceiros/111577197323430.png',
      situation: 1
    },
    {
      id: 2,
      title: 'Desafio 2',
      description: 'Descricao do desafio',
      image: 'parceiros/111577197323430.png',
      situation: 3
    },
    {
      id: 3,
      title: 'Desafio 3',
      description: 'Descricao do desafio',
      image: 'parceiros/111577197323430.png',
      situation: 1
    }
  ])
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Desafios',
      buttons: [{ title: 'Adicionar Desafio', pathname: '/challengeform' }]
    })
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('challenges', searchData.str).then(r => {
        setChallengeList(r)
        setSearchData({ ...searchData, startSearch: false })
        setIsLoading(false)
      })
    }
  }, [searchData])

  const handleSearch = () => {}
  return (
    <div className="container-fluid">
      <Grid container xs={12} style={{ padding: 15 }}>
        <Grid item xs={12} justify="center">
          <ToastMessages />
          <Context.Provider value={{ searchData, setSearchData }}>
            <TopSearch searchAction={handleSearch} />
          </Context.Provider>
        </Grid>
        <Grid item xs={12} justify="center">
          <div className="row">
            {challengeList.map(item => (
              <div
                key={item.id}
                style={{ padding: '10px' }}
                className="col-lg-3 col-md-6 col-sm-12"
              >
                <div className="card card-clube">
                  <img
                    className="card-img-top "
                    src={item.image !== '' ? REACT_APP_IMAGES_URL + item.image : changeLogo}
                    alt={item.title}
                  />
                  <div className="card-body">
                    <h4
                      className="card-title w-100 d-flex justify-content-between align-content-center"
                      style={{ minHeight: 60 }}
                    >
                      {item.title}{' '}
                      {item.situation === 3 && (
                        <small style={{ fontSize: 12, color: 'red' }}>Rascunho</small>
                      )}
                      {item.situation === 1 && (
                        <small style={{ fontSize: 12, color: 'green' }}>Publicado</small>
                      )}
                    </h4>
                    <p>{item.description}</p>
                  </div>
                  <div className="card-body d-flex align-content-center justify-content-between ">
                    <button
                      // disabled={checkLoading(partner.id)}
                      className={`card-link btn ${
                        item.situation === 3 ? 'btn-success' : 'btn-danger'
                      }`}
                      onClick={() => {}}
                      type="button"
                    >
                      {item.situation === 3 ? 'Publicar' : 'Desativar'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default ChallengeList
